// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2850":"589437e8487c0aac","4928":"effbf8c015fe86dd","8719":"b39dbd97004bc4b5","9078":"c796f0bc88917655"}[chunkId] + ".css";
};